import { ExportToRegistryDto } from "types/dto/ExportToRegistryDto";
import * as registryService from 'services/registriesService';
import { useMutation, useQuery } from "react-query";
import { ListRegistriesDto } from "types/dto/ListRegistriesDto";
import { ListRegistryPatientsDto } from "types/dto/ListRegistryPatientsDto";
import { GetRegistryPatientDto } from "types/dto/GetRegistryPatientDto";


export const useExportCasesToRegistry = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(registryService.exportCasesToRegistry, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useCreateRegistry = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(registryService.createRegistry, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useUpdateRegistry = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(registryService.updateRegistry, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useGetRegistries = (dto: ListRegistriesDto, options = {}) => {
  return useQuery({
    queryKey: ['registries', dto],
    queryFn: () => registryService.getRegistries(dto),
    ...options,
  })
}

export const useGetRegistryById = (registryId: number, options = {}) => {
  return useQuery({
    queryKey: ['registry', registryId],
    queryFn: () => registryService.getRegistryById(registryId),
    ...options,
  })
}

export const useGetRegistryPatients = (dto: ListRegistryPatientsDto, options = {}) => {
  return useQuery({
    queryKey: ['registry-patients', dto],
    queryFn: () => registryService.getRegistryPatients(dto),
    ...options,
  })
}

export const useDeleteRegistry = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(registryService.deleteRegistry, {
    onSuccess,
    onError,
    ...options,
  });
}
